import { Component, Input } from '@angular/core';
import { ApplicationState } from '@shared/enum';

@Component({
  selector: 'app-status',
  templateUrl: './app-status.component.html',
  styleUrls: ['./app-status.component.scss'],
  standalone: true,
  imports: []
})
export class AppStatusComponent {
  /** Loan status */
  @Input() public status: string;
  /** Status custom css classes */
  @Input() public statusClass = '';
  /** Status custom css classes */
  @Input() public statusIconClass = '';
  /** show status text based on lender config */
  @Input() statusText?: string = '';

  public getStatus(): string {
    return this.statusText ? this.statusText : this.status;
  }

  public statusIcon(status: string): string {
    if (status) {
      switch (status.toLowerCase()) {
        case ApplicationState.OnTrack:
          return 'cu-check';
        case ApplicationState.UnderReview:
          return 'cu-folder-edit';
        case ApplicationState.CounterOffered:
        case ApplicationState.Approved:
        case ApplicationState.ConditionallyApproved:
        case ApplicationState.ReadyToFund:
        case ApplicationState.Funded:
          return 'cu-approved';
        case ApplicationState.AtRisk:
        case ApplicationState.ContactYourLender:
        case ApplicationState.Withdrawn:
          return 'cu-warning-circle';
      }
    }
  }

  public statusColorClass(status: string): string {
    if (status) {
      switch (status.toLowerCase()) {
        case ApplicationState.OnTrack:
        case ApplicationState.UnderReview:
        case ApplicationState.CounterOffered:
        case ApplicationState.Approved:
        case ApplicationState.ConditionallyApproved:
        case ApplicationState.ReadyToFund:
        case ApplicationState.Funded:
          return 'bl-font-color--success';
        case ApplicationState.AtRisk:
        case ApplicationState.ContactYourLender:
        case ApplicationState.Declined:
          return 'bl-font-color--warning';
        case ApplicationState.Withdrawn:
        case ApplicationState.Pending:
          return 'bl-font-color--black';
        default:
          return 'bl-font-color--black';
      }
    }
  }
}
